module.exports = __webpack_public_path__ + "static/media/prsto-home-section.435266be.png";